const getPatron = () => {
  if (typeof window === 'undefined') return false;
  const patron = localStorage.getItem('rfs:patron');
  return patron || false;
};

export default {
  patron: getPatron(),
  user: false,
};
